import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { getUserProfileUrl, updatePasswordUrl, updateUserProfileUrl } from '../../shared/helpers/endPoints';
import { GET_USER_PROFILE, UPDATE_PASSWORD, UPDATE_USER_PROFILE } from './actionTypes';
import { fetchJSON } from '../../shared/helpers/apiCalls';
import { setUserProfile } from './action';
import { setError, setProcessLoading, setSuccess, setUpdatePasswordError } from '../utils/action';
import { getStoreLocal } from '../../shared/helpers/utils';
import { authService } from '../../modules/users/services/dependency.injection';

function* callUpdatePassword({ payload: value }) {
    // token after the user has logged in
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: updatePasswordUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            },
            data: JSON.stringify(value)
        };

        yield call(fetchJSON, options);
        yield put(setUpdatePasswordError(''));
        yield put(setSuccess('Password has been successfully updated'));
        yield put(setProcessLoading(false));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;

        yield put(setProcessLoading(false));
        yield put(setError(message));
        // yield put(setUpdatePasswordError(message))
    }
}

function* callUpdateUserProfile({ payload: value }) {
    // token after the user has logged in
    const access_token = authService.accessToken();
    const { user_id } = authService.userInfo();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'PUT',
            url: updateUserProfileUrl(modeType, user_id),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
                // 'X-AUTH-PASSWORD': 'password',
            },
            data: JSON.stringify(value)
        };

        const response = yield call(fetchJSON, options);

        yield put(setUserProfile(response.data));
        yield put(setProcessLoading(false));
        yield put(setSuccess('Profile updated successfully'));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;

        yield put(setProcessLoading(false));
        yield put(setError(message));
    }
}

function* callGetUserProfile() {
    // token after the user has logged in
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const user = authService.userInfo();
        const options = {
            method: 'GET',
            url: getUserProfileUrl(modeType, user.user_id),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            }
        };

        const response = yield call(fetchJSON, options);
        yield put(setUserProfile(response.data));
        // yield put(setMerchantCategory(response.data.content));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}

export function* watchCallUpdatePassword() {
    yield takeEvery(UPDATE_PASSWORD, callUpdatePassword);
}
export function* watchGetUserProfile() {
    yield takeEvery(GET_USER_PROFILE, callGetUserProfile);
}
export function* watchUpdateUserProfile() {
    yield takeEvery(UPDATE_USER_PROFILE, callUpdateUserProfile);
}

function* profileSaga() {
    yield all([fork(watchGetUserProfile), fork(watchUpdateUserProfile), fork(watchCallUpdatePassword)]);
}

export default profileSaga;
